import styled from 'styled-components'

import Etc from '~/features/general-participation/components/Etc'
import Shop from '~/features/general-participation/components/Shop'
import { type ShopInfo } from '~/features/general-participation/types/general-participation'

type Props = {
  data: ShopInfo
}

function GeneralInfoIntroduction({ data }: Props) {
  return (
    <Wrapper>
      <Shop data={data} />
      <Etc data={data.etc} />
    </Wrapper>
  )
}

export default GeneralInfoIntroduction

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;
`
